import { render, staticRenderFns } from "./slideregion4.vue?vue&type=template&id=7da28c15&"
import script from "./slideregion4.vue?vue&type=script&lang=js&"
export * from "./slideregion4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports